import {
  defineStore
} from 'pinia'
import config from '@/config/index'

const defaultAvatarSrc = '@/assets/images/wu.jpg'
export const useAccountStore = defineStore('account', {
  state: () => {
    return {
      userInfo: {
        avatar: defaultAvatarSrc,
        token: config?.token || null,
      },
      tokenStartTime: null,
      tokenEndTime: null
    }
  },
  getters: {
    tokenInvalid: (state) => {
      return !state.userInfo.token;
    },
    tokenOutTime: (state) => {
      return Date.parse(new Date()) > state.tokenEndTime
    },
    getUserInfo: (state) => {
      return state.userInfo
    }
  },
  actions: {
    signin(data) {
      data.avatar = data.avatar === "" ? defaultAvatarSrc : data.avatar;
      this.userInfo = data;
      localStorage.setItem("accountUserInfo", this.userInfo);

      this.tokenStartTime = Date.parse(new Date()) / 1000;
      localStorage.setItem("tokenStartTime", this.tokenStartTime);
      localStorage.setItem("tokenEndTime", this.tokenStartTime + config.TOKEN_TIME);
    },
    signout() {
      this.userInfo = {
        avatar: defaultAvatarSrc,
      };
      this.tokenStartTime = null;
      this.tokenEndTime = null;
      localStorage.removeItem("accountUserInfo");
      localStorage.removeItem("tokenStartTime");
      localStorage.removeItem("tokenEndTime");
    },
  }
})
